import { render, staticRenderFns } from "./CurrenciesAddNew.vue?vue&type=template&id=3bde8e04&"
import script from "./CurrenciesAddNew.vue?vue&type=script&lang=js&"
export * from "./CurrenciesAddNew.vue?vue&type=script&lang=js&"
import style0 from "./CurrenciesAddNew.vue?vue&type=style&index=0&id=3bde8e04&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports